import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('./pages/HomePage.vue')
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('./pages/ListPage.vue')
  },
  {
    path: '/types',
    name: 'types',
    component: () => import('./pages/TypesPage.vue')
  },
  {
    path: '/brickify',
    name: 'brickify',
    component: () => import('./pages/BrickifyPage.vue')
  },
  {
    path: '/pokedex/:id?/:version?',
    name: 'pokedex',
    component: () => import('./pages/PokedexPage.vue')
  },
  {
    path: '/palette/:id?/:version?',
    name: 'palette',
    component: () => import('./pages/PalettePage.vue')
  },
  {
    path: '/instagram/:id?/:version?',
    name: 'instagram',
    component: () => import('./pages/InstagramPage.vue')
  },
  {
    path: '/lego/:id?/:version?',
    name: 'lego',
    component: () => import('./pages/LegoPage.vue')
  },
  {
    path: '/codename/:id?/:codename?',
    name: 'codename',
    component: () => import('./pages/CodenamePage.vue')
  },
  {
    path: '/pokemon/:id?/:codename?',
    redirect: to => {
      if (to.params.id && to.params.codename) {
        return `/codename/${to.params.id}/${to.params.codename}`;
      }

      if (to.params.id) {
        return `/codename/${to.params.id}`;
      }

      return '/codename';
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('./pages/NotFoundPage.vue')
  }
];

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});
